
import { Vue } from 'vue-property-decorator';

export default class IconClose extends Vue {}
